module.exports = __webpack_public_path__ + "img/annelie-baensch-avatar.6920300c.jpg";